// WhipStir Settings
module.exports = {
      defaultRecipeGalleryImage: '/img/recipes/Whipstir_NoImageAvailable.jpg',
      defaultRecipeHeaderBackground: '/img/temp/cook.jpg',
      foodFacts: [
          "Peaches and nectarines are essentially the same fruit.",
          "McDonald's fries were cooked in beef fat until 1990.",
          "German chocolate cake didn't originate in Germany.",
          "Otis Spunkmeyer is a combination of the names of football player Otis Sistrunk and popcorn maker Orville Redenbacher.",
          "Spam is a mashup of the words 'spice' and 'ham.'",
          "Most wasabi is just horseradish that's dyed green.",
          "Cashews grow on cashew apples.",
          "Cilantro and fresh coriander are the same thing.",
          "Peppers have more vitamin C than oranges.",
          "Lemons float, but limes sink.",
          "A single spaghetti noodle is called a spaghetto.",
          "Broccoli contains more protein, by volume, than steak.",
          "Caesar salad originated in Tijuana, Mexico.",
          "Did you know it can take 7 to 21 days to make a jelly bean?",
          "Bananas are actually classified as berries, while strawberries are members of the rose family.",
          "Many shredded cheeses and cereals contain cellulose (wood pulp).",
          "Green, yellow, and red bell peppers are not actually the same vegetable.",
          "One burger patty can contain the meat from hundreds of different cows.",
          "Despite its name, white chocolate doesn't actually contain any real chocolate.",
          "Farm-raised salmon is naturally white and then dyed pink.",
          "The red food dye used in Skittles is made from boiled beetles.",
          "People once thought tomatoes were poisonous.",
          "Grapes will explode if you put them in the microwave.",
          "Processed cheese was invented in Switzerland, not America."
      ]
  };